module.exports = __webpack_public_path__ + "img/can-it-kill-you.115d0a69.jpg";